/*
 * bc-weight-format
 *
 * Shared unit-conversion + display formatter for variant weights. Used by
 * bc-variant-weight and bc-diagram so both render identically.
 *
 * Exposes `window.bcWeightFormat`:
 *   - fromGrams(grams, unit) → number in the target unit (1× fallback)
 *   - formatWeight(value, unit) → "1.7 kg" (1 decimal place for every
 *     unit, trailing zero preserved so a 1.0 kg variant still reads as
 *     "1.0 kg" and lines up cleanly next to fractional values)
 *
 * IIFE-guarded so multiple block instances can load this asset on the
 * same page without re-defining.
 */
(() => {
  if (window.bcWeightFormat) return;

  const TO_GRAMS = { g: 1, kg: 1000, oz: 28.3495, lb: 453.592 };

  function fromGrams(grams, unit) {
    const f = TO_GRAMS[unit];
    return Number.isFinite(f) ? grams / f : grams;
  }

  function formatWeight(value, unit) {
    // toLocaleString (en-US) groups thousands with commas; the fixed
    // min/max fraction digits keep the original one-decimal behavior
    // (so 1.0 kg still reads "1.0 kg" and 1234.5 reads "1,234.5").
    // Grams are the exception: sub-gram precision is noise at that
    // magnitude, so they render whole ("183 g", not "183.0 g").
    const digits = unit === 'g' ? 0 : 1;
    const formatted = value.toLocaleString('en-US', {
      minimumFractionDigits: digits,
      maximumFractionDigits: digits,
    });
    return `${formatted} ${unit}`;
  }

  window.bcWeightFormat = { fromGrams, formatWeight };
})();
